import { ref, uploadBytes } from "firebase/storage";
import { storage } from "./firebase";

export const uploadFile = async ({ file, path, metadata }) => {
  // Create a reference to file
  const storageRef = ref(storage, path, metadata);

  // 'file' comes from the Blob or File API
  const snapshot = await uploadBytes(storageRef, file);

  return snapshot.metadata.fullPath;
};
